<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="pb-10 pt-4">
    <button
      class="flex cursor-pointer items-start hover:text-blue-400 hover:underline"
      @click="handleToggle"
    >
      <IconCaret
        :direction="isShow ? 'up' : 'down'"
        class="block h-7 w-7 basis-7 text-blue-400"
      />
      <span class="mb-2 block flex-1 pl-4 text-lg font-bold">
        {{ sectionData.name }}
      </span>
    </button>
    <div v-if="isShow">
      <div
        class="description pl-11 text-sm leading-6 text-gray-600"
        v-html="provideSanitized(sectionData.description || '')"
      />
      <AreaHelpContactUsFaqCardAccordion
        v-if="sectionData.subSections.length"
        :section-data="sectionData.subSections"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { ISection } from '@/assets/types/api/Pages';

  interface IProps {
    sectionData: ISection;
    isFirst: boolean;
  }

  const props = withDefaults(defineProps<IProps>(), {
    sectionData: () => ({
      code: null,
      name: null,
      description: null,
      type: 1,
      imageUrl: null,
      imageAlt: null,
      link: null,
      align: null,
      theme: null,
      subSections: [],
    }),
    isFirst: false,
  });

  const isShow = ref<boolean>(props.isFirst);

  const handleToggle = (): void => {
    isShow.value = !isShow.value;
  };
</script>

<style lang="scss" scoped>
  .description:deep(a) {
    @apply text-blue-400 hover:underline;
  }

  .description:deep(ul) {
    @apply list-disc pl-7;
  }

  .description:deep(ol) {
    @apply list-decimal pl-6;
  }
</style>
